import { toRootDomain } from "./toRootDomain.js";

export function resolveHomeSite(): string {
  const rootDomain = toRootDomain(location.hostname);
  return location.origin.replace(location.hostname, rootDomain);
}
